import { forwardRef, Fragment, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";
import { ScrollbarPropsType, Scrollbars } from "../../Scrollbars";

import styles from "./styles.module.scss";

export type DropdownListProps = HtmlHTMLAttributes<HTMLDivElement> & {
  header?: ReactNode
  footer?: ReactNode
  scrollbarProps?: ScrollbarPropsType
}

export const DropdownList = memo(forwardRef<HTMLDivElement, DropdownListProps>((
  {
    children,
    className,
    header,
    footer,
    scrollbarProps,
    ...props
  },
  ref,
) => {
  return (
    <div
      ref={ref}
      className={classNames(className, styles.root)}
      {...props}
    >
      <Fragment key="header">
        {header}
      </Fragment>
      <Scrollbars
        key="scrollbars"
        {...scrollbarProps}
        className={classNames(scrollbarProps?.className, styles.scrollbar, "os-host-flexbox")}
      >
        {children}
      </Scrollbars>
      <Fragment key="footer">
        {footer}
      </Fragment>
    </div>
  );
}));